module.exports = __webpack_public_path__ + "static/media/eclos-brand-catalog-bg.9c8ad4ab.png";